import styles from "./styles.module.scss";
import cn from "classnames";

export const Specialisms = ({ categoryLabel, title, description, specialisms, className }) => {
  return (
    <section className={cn(styles.Specialisms, className)}>
      <div className={styles.header}>
        <div className={styles.headerGroup}>
          <div className={styles.label} data-sourceflow-prop="categoryLabel">
            {categoryLabel}
          </div>
          <h2 className={styles.title} data-sourceflow-prop="title">
            {title}
          </h2>
        </div>
        <div
          className={styles.description}
          data-sourceflow-prop="description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>

      <div className={styles.grid}>
        {specialisms?.map(({ name, subtitle, image }, idx) => (
          <div key={idx} className={styles.card} style={{ backgroundImage: `url(${image?.url})` }}>
            <div className={styles.cardContent}>
              <div className={styles.cardTitle} data-sourceflow-prop={`specialisms[${idx}].name`}>
                {name}
              </div>
              {subtitle && (
                <div className={styles.cardSubtitle} data-sourceflow-prop={`specialisms[${idx}].subtitle`}>
                  {subtitle}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Specialisms;
